<div class="back-to-welcome-container light-control-host">
  @if (showBackToWelcome) {
    <button class="arpio-button small-button back-to-welcome" (click)="navigateBackToWelcome()">
      <i class="fa-solid fa-arrow-left"></i> Back to Welcome
    </button>
  }
  @if (showBackToWelcome) {
    <div class="back-to-welcome-spacer"></div>
  }
  <div id="account-settings-container" class="content-block light-control-host">
    <div class="header-container">
      <div>
        <h1>Arpio Account Settings</h1>
      </div>
    </div>

    <app-tabs [tabs]="tabs" [baseRoute]="baseRoute" [scrollTargetId]="'account-settings-content'"></app-tabs>

    <div id="account-settings-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
